<template>
	<div>
		<el-card shadow="never">
			<div>
				<el-form size="small" :inline="true" label-position="right" label-width="120px" :rules="rules" :model="formData">
					<el-form-item label="原车牌号码">
						<el-input
							size="small"
							v-model="formData.oldPlateNumber"
							:disabled="!!formData.cardId"
						></el-input>
					</el-form-item>
					<el-form-item label="新车牌号码" prop="plateNumber">
						<el-input
							size="small"
							v-model="formData.plateNumber"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSave">保存</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import dlgForm from "@/mixin/dlgForm";

export default {
	name: "ModifyCarIdForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				plateNumber: [{ required: true, message: "请输入新车牌号码", trigger: "blur" }]
			},
		};
	},
	methods: {
		doSave() {
            const url = '/car/web/carManage/card/plate';
            this._doSaveForm(this.$refs.form, url, 'POST');
		},
	},
};
</script>
